// TDIC - getProxiedUrl is added based on requirement
import { getProxiedServiceUrl, getProxiedUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';

export default class PolicyService {
    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries', [], authHeader);
    }

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('removePolicyDocument'), 'removeDocument', [publicID], authHeader);
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadPolicyDocument'), document, documentMetadata, authHeader);
    }

    static getDocumentUploadToken(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('generateUploadToken'), 'generateUploadToken', params, additionalHeaders);
    }

    // TDIC - Added - Following method to get risk management for professional liability
    static getRiskMgmtForProfessionalLiability(additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getRiskMgmtForProfessionalLiability', [], additionalHeaders);
    }

    // TDIC - Added - Following method to get expiring risk management courses
    static getExpiringRiskManagementCourses(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getExpiringRiskManagementCourses', [], authHeader);
    }

    // TDIC - Added - Following method to get terms and conditions.
    static getTermsAndCondtions(requestOptions) {
        return fetch(getProxiedUrl('/dnn-terms-and-conditions'), requestOptions);
    }

    // TDIC - Added - Following method to download document link.
    static downloadDocumentLink(documentID, sessionID) {
        const downloadURL = getProxiedServiceUrl('policyDocumentDownload');
        return fetch(`${downloadURL}/${documentID}?token=${sessionID}`);
    }

    // TDIC - Added - Following method to get TnC Transaction SubTypes.
    static getTnCTransactionTypesSubTypes(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('termsAndConditionsExt'), 'getTnCTransactionTypesSubTypes', [], authHeader);
    }

    // TDIC - Added - Following method for user has accepted the TnC
    static hasUserAcceptedTnC(requestOptions, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('termsAndConditionsExt'), 'hasUserAcceptedTnC', [requestOptions], authHeader);
    }

    // TDIC - Added - Following method to save user Terms and Conditions.
    static saveUserTermsAndConditions(requestOptions, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('termsAndConditionsExt'), 'saveUserTermsAndConditions', [requestOptions], authHeader);
    }

    // TDIC - Added - Following mehtod to get accepted TnC Count.
    static getAcceptedTnCCount(requestOptions, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('termsAndConditionsExt'), 'getAcceptedTnCCount', [requestOptions], authHeader);
    }

    // TDIC - Added - Following method to retrieve policies for policy change survey.
    static retrievePoliciesForPolicyChangeSurvey(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('userSurvey'), 'retrievePoliciesForPolicyChangeSurvey', [], authHeader);
    }

    // TDIC - Added - Following method to send policy change survey.
    static sendPolicyChangeSurvey(authHeader = {}, renewalSurvey) {
        return JsonRPCService.send(getProxiedServiceUrl('userSurvey'), 'sendPolicyChangeSurvey', [renewalSurvey], authHeader);
    }

    // TDIC - Added - Following method to lookup melissa address.
    static lookupMelissaAddress(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('addressLookupMelissa'), 'validateAddress', [data], additionalHeaders);
    }

    // TDIC - Added - Following method to get policy and offerings.
    static getPolicyAndOfferings(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getPolicyAndOfferings', [], authHeader);
    }

    // TDIC - Added - Following method to get policy locations and change reasons.
    static getPolicyLocationsAndChangeReasons(data, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('serviceRequest'), 'getPolicyLocationsAndChangeReasons', [data], authHeader);
    }

    // TDIC - Added - Following method to get Ad Banner List.
    static getAdBannerList() {
        return fetch(getProxiedUrl('/cms-ad-banner'));
    }

    // TDIC - Added - Following method to send policy change survey.
    static sendSurveyResponse(authHeader = {}, renewalSurvey) {
        return JsonRPCService.send(getProxiedServiceUrl('userSurvey'), 'receiveSurveyResponse', [renewalSurvey], authHeader);
    }
}
